<template>
  <template v-if="hasTitles">
    <GamChip v-if="player?.title" :size="size" is-active is-upper-case>
      {{ localize(PlayerHelper.getPlayerTitleLocale(player.title, longTitle)) }}
    </GamChip>

    <template v-if="getPlayerTypes">
      <template v-if="getPlayerTypes.includes(PlayerType.COACH) && isCoachShown">
        <GamChip :size="size" is-active is-upper-case>
          {{ localize(PlayerHelper.getPlayerTypeLocale(PlayerType.COACH)) }}
        </GamChip>
      </template>

      <template v-if="getPlayerTypes.includes(PlayerType.STREAMER) && isStreamerShown">
        <GamChip :size="size" is-active is-upper-case>
          {{ localize(PlayerHelper.getPlayerTypeLocale(PlayerType.STREAMER)) }}
        </GamChip>
      </template>

      <template v-for="(type, ti) in getPlayerTypes">
        <GamChip v-if="false" :size="size" :key="`player-${player.id}-${ti}`" is-active is-upper-case>
          {{ localize(PlayerHelper.getPlayerTypeLocale(type)) }}
        </GamChip>
      </template>
    </template>
  </template>
</template>

<script lang="ts" setup>
import type { BaseUserDto } from '@/core/data/user/user.interface';
import { PlayerType } from '@/core/data/user/user.type';
import { localize } from '@/core/gambits';
import PlayerHelper from '@/core/helpers/player.helper';
import { GamChipSize } from '@/views/composables/constants/components/gamChip.constants';
import { computed } from 'vue';
import GamChip from '../GamChip.vue';

export interface GamPlayerRolesProps {
  player: BaseUserDto;
  size?: GamChipSize;
  showAll?: boolean;
  showCoach?: boolean;
  showStreamer?: boolean;
  longTitle?: boolean;
}

const props = withDefaults(defineProps<GamPlayerRolesProps>(), {
  player: undefined,
  size: GamChipSize.NORMAL,
  longTitle: false,
});

const isDefault = computed(() => {
  return props.showAll === undefined && props.showStreamer === undefined && props.showCoach === undefined;
});
const isStreamerShown = computed(() => {
  return props.showAll === true || props.showStreamer === true || isDefault.value === true;
});
const isCoachShown = computed(() => {
  return props.showAll === true || props.showCoach === true || isDefault.value === true;
});

const getPlayerTypes = computed((): PlayerType[] | undefined => {
  return props.player?.playerTypes?.filter((type) => type !== PlayerType.GAMBIT_MASTER);
});

const hasTitles = computed(() => {
  return getPlayerTypes.value?.length || props.player?.title?.length;
});
</script>

<style lang="scss" scoped>
.player-roles {
  display: inline-flex;
  justify-content: flex-start;
}

.gam-player-roles {
  display: inline-flex;
  justify-content: flex-start;

  &.spacing-l {
    gap: var(--spacing-l);
  }
  &.spacing-m {
    gap: var(--spacing-m);
  }
  &.spacing-s {
    gap: var(--spacing-s);
  }

  .titled {
    color: var(--color-pink);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .type {
    color: var(--color-yellow);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
